"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var retina = false;
if (window.devicePixelRatio > 1) {
    retina = true;
}
exports.RETINA = retina;
exports.VERSION = 'v5.16';



//////////////////
// WEBPACK FOOTER
// ./src/constants.ts
// module id = 43
// module chunks = 0